import React, {useState} from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Footer from '../components/Footer';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { useHistory, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import AuthActions from '../actions/auth.actions';

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

const StyledTextField = styled(TextField)`
    margin-bottom: 10px;
    background: #3f3f3f;
    border-color:  #3f3f3f!important;
    * {
        border-color:  #00FFFF!important;
    }
    label, input {
        color: #fff!important
    }
`

const StyledBtn = styled(Button)`
    background: #00FFFF!important;
    border-color: #00FFFF!important; 
    padding-left: 25px;
    padding-right: 25px;
    color: #000
`

const StyledContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 50px;
`

const Home = (props) => {

    let query = useQuery();

    const initialFormdata = {
        tkn_usr_id: query.get('tkn_usr_id'),
        emailAddress: query.get('emailAddress'),
        token: query.get('token'),
        password: "",
        confirmPassword: ""
    }
    const [formData,  setFormData] = useState(initialFormdata);
    const history = useHistory()
    return (
        <div style={{background: '#3f3f3f', minHeight: '100%'}}>
            <Container fixed>
                <Typography component="div" align="center" style={{ height: '100vh', paddingTop: '70px' }}>
                    <h1>Reset your <span style={{color: 'white'}}>Mystery</span>QR Password</h1>
                    <StyledContainer>
                        <div style={{display: 'flex', flexDirection: 'column', width: "300px"}}>
                            <StyledTextField id="email" type="text" label="Email Address" variant="outlined" defaultValue={formData.emailAddress} disabled/>
                            <StyledTextField id="password" type="password" label="New Password" variant="outlined"  value={formData.password} onChange={(ev)=>{
                                setFormData({...formData, ...{
                                    password: ev.target.value
                                }})
                            }} />
                            <StyledTextField id="confirm_password" type="password" label="Confirm Password" variant="outlined"  value={formData.confirmPassword} onChange={(ev)=>{
                                setFormData({...formData, ...{
                                    confirmPassword: ev.target.value
                                }})
                            }} />
                            
                            <StyledBtn variant="outlined" color="primary" onClick={()=>{
                                props.resetPassword(formData, ()=>{
                                    console.log('now move to home')
                                    history.push("/");
                                })
                            }}>
                                Update Password
                            </StyledBtn>
                        </div>
                    </StyledContainer>
                </Typography>
                <Footer/>
            </Container>
        </div>)
}

const mapStateToProps = state=>{
    return state;
}

const mapDispatchToProps = dispatch => {
    return {
        resetPassword: (payload, cb)=>dispatch(AuthActions.resetPassword(payload, cb))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);